import { Tab } from '@nxtpeople/nxt-styles/dist/types/components/layout-elements/NxtTabContainer.vue';
import { computed, provide, Ref, ref } from 'vue';

export function useTabs<T extends Tab>(tabs: Ref<Array<T>>) {
   const activeTabKey = ref(tabs.value[0].key);
   const activeTabIndex = computed(() => tabs.value.findIndex((t) => t.key === activeTabKey.value) || 0);
   const activeTab = computed(() => tabs.value[activeTabIndex.value]);
   const isFirstTab = computed(() => tabs.value[0].key === activeTabKey.value);
   const isLastTab = computed(() => tabs.value[tabs.value.length - 1].key === activeTabKey.value);

   provide('activeTabKey', activeTabKey);

   function goToTabIndex(tabIndex: number) {
      activeTabKey.value = tabs.value[tabIndex].key;
   }
   function nextTab() {
      goToTabIndex(activeTabIndex.value + 1);
   }
   function previousTab() {
      goToTabIndex(activeTabIndex.value - 1);
   }

   const variables = { activeTabKey, activeTabIndex, activeTab, tabs, isFirstTab, isLastTab };
   const methods = { nextTab, previousTab, goToTabIndex };

   return { ...variables, ...methods };
}
